// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__3PmkM","largePadding":"styles_largePadding__1Zi1r","selected":"styles_selected__13mhc","hoverable":"styles_hoverable__1toYj"};